module.exports = __webpack_public_path__ + "img/6e0bd9d.jpg";